/**
 * Created by shakibuz.zaman on 5/16/2019.
 */
import { environment } from "src/environments/environment";



export class PreferenceConfig {
  static getEmailPreferenceV2(token: string) {
    return `${environment.dynamicsettings['PlatformApi']}NotificationPreference/UserNotificationPreference?code=${token}`;
  }
  static setEmailPreferenceV2() {
    return `${environment.dynamicsettings['PlatformApi']}NotificationPreference/UpdateUserNotificationPreference`;
  }
  static getEmailPreference(token: string) {
    return `${environment.dynamicsettings['PlatformApi']}AlertPreference?code=${token}`;
  }
  static setEmailPreference() {
    return `${environment.dynamicsettings['PlatformApi']}AlertPreference/UpdatePreferences`;
  }
}
